import { render, staticRenderFns } from "./DynamicContent.vue?vue&type=template&id=f8e2163a&scoped=true&"
import script from "./DynamicContent.vue?vue&type=script&lang=js&"
export * from "./DynamicContent.vue?vue&type=script&lang=js&"
import style0 from "./DynamicContent.vue?vue&type=style&index=0&id=f8e2163a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e2163a",
  null
  
)

export default component.exports